import InputDate from './InputDate';

export default InputDate;